import { render } from "./AddListOrder.vue?vue&type=template&id=08866345"
import script from "./AddListOrder.vue?vue&type=script&lang=js"
export * from "./AddListOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__